var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88843 20.905V14.5476H15.1058V20.905C15.1058 21.6043 15.6927 22.1765 16.4101 22.1765H20.3231C21.0405 22.1765 21.6275 21.6043 21.6275 20.905V12.0046H23.8448C24.4448 12.0046 24.7318 11.2799 24.2753 10.8985L13.371 1.32423C12.8754 0.891924 12.1188 0.891924 11.6232 1.32423L0.718936 10.8985C0.275461 11.2799 0.549372 12.0046 1.14937 12.0046H3.36674V20.905C3.36674 21.6043 3.95369 22.1765 4.67108 22.1765H8.58409C9.30148 22.1765 9.88843 21.6043 9.88843 20.905Z",
    fill: "#8086B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.22840ee9.svg";
export { ForwardRef as ReactComponent };